import type { CustomField } from "@/schema"

import type { PlaceholderData } from "@/components/lexical/placeholders"

function getFieldDescription(field: CustomField): string | undefined {
  switch (field.field_type) {
    case "date":
      return "Formatted as month day, year (e.g. January 15, 2025)"
    case "boolean":
      return 'Displays as "Yes" or "No"'
    case "number":
      if (field.format === "currency") return "Formatted as currency (e.g. $1,234.56)"
      if (field.format === "percentage") return "Formatted as percentage (e.g. 15.5%)"
      return undefined
    case "cross_reference":
      return "Displays the name of the referenced record"
    case "user_reference":
      return "Displays the full name of the assigned user"
    default:
      return undefined
  }
}

const NON_RENDERABLE_FIELD_TYPES: CustomField["field_type"][] = ["rich_text"]

export function customFieldsToPlaceholders(customFields: CustomField[]): PlaceholderData[] {
  return customFields
    .filter((field) => !NON_RENDERABLE_FIELD_TYPES.includes(field.field_type))
    .map((field) => ({
      id: `cf_${field.field_key}`,
      label: field.display_name,
      value: `{{ household.custom_fields.${field.field_key} }}`,
      category: "Custom fields",
      description: getFieldDescription(field),
    }))
}
